import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Apple-style parallax: child drifts as the section scrolls through the viewport.
export const Parallax = ({ children, distance = 80, className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [distance, -distance]);
  return (
    <div ref={ref} className={`relative ${className}`}>
      <motion.div style={{ y }}>{children}</motion.div>
    </div>
  );
};

// Scale + subtle zoom reveal for large imagery (Apple product-style).
export const ParallaxImage = ({ src, alt, className = "", imgClassName = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.18, 1.06, 1.18]);
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img src={src} alt={alt} style={{ scale, y }} className={`w-full h-full object-cover ${imgClassName}`} loading="lazy" />
    </div>
  );
};
